import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Internal' },
    { value: 2, label: 'Google Drive' },
    { value: 3, label: 'YouTube' },
    { value: 4, label: 'Cloudflare' },
    { value: 999, label: 'Other' },
  ],
});
